<template>
  <div>
    <el-table ref="multipleTable"
              :data="dataList"
              tooltip-effect="dark"
              height="100%" style="width: 100%"
              @row-click="clickFn"
              @row-dblclick="dblclickFn"
              @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="序号" align="center" prop="index" width="50"></el-table-column>
      <el-table-column label="标题" align="center" prop="name"></el-table-column>
      <el-table-column label="组件名" align="center" prop="compName"></el-table-column>
      <el-table-column label="组件类型" align="center" prop="type"></el-table-column>
      <el-table-column label="数据展示时间段" align="center" prop="statDate1"></el-table-column>
      <el-table-column label="创建时间" align="center" prop="createDate"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'list',
  props: {
    dataList: {
      Array,
      default: []
    }
  },
  methods: {
    handleSelectionChange(selectArrys) {
      for (let i = 0; i < this.dataList.length; i++) {
        let item = this.dataList[i];
        item.checked = false;
      }
      for (let i = 0; i < selectArrys.length; i++) {
        selectArrys[i].checked = true;
      }
    },
    clickFn(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    dblclickFn(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
      this.$emit('detail');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
